// theme.ts
import { createTheme } from '@mui/material/styles';

/**
 * const YELLOW = Color(0xffEFDA56);
 * const WHITE = Color(0xffFFFBF3);
 * const TURQUOISE = Color(0xff104040);
 * const BLUE = Color(0xff527575);
 * const BURGUNDY = Color(0xff652a26);
 * const RED = Color(0xffb81e11);
 * const DARK_BACKGROUND = Color(0xFF272727);
 * const LIGHT_GREY = Color(0xFFB0B0B0);  // #B0B0B0
 */

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#104040', // Material 2 Purple
        },
        secondary: {
            main: '#EFDA56', // Material 2 Teal
        },
        background: {
            default: '#FFFFFF',
            paper: '#F5F5F5',
        },
        text: {
            primary: '#000000',
            secondary: '#757575',
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#EFDA56', // YELLOW
        },
        secondary: {
            main: '#104040' // TURQUOISE
        },
        background: {
            default: '#272727', // DARK_BACKGROUND
        },
        error: {
            main: '#652a26', // BURGUNDY
        },
        text: {
            primary: '#B0B0B0', // LIGHT_GREY
            secondary: '#FFFBF3', // WHITE
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});
